var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWildberries = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  viewBox: "0 0 100 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wildberries_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#wildberries_svg__b)",
  d: "M73.87 0H26.13C11.7 0 0 11.7 0 26.13v47.74C0 88.3 11.7 100 26.13 100h47.74C88.3 100 100 88.3 100 73.87V26.13C100 11.7 88.3 0 73.87 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 2.764,
  d: "M27.386 68.593h-7.067L9.8 31.156h6.43l7.81 29.255 8.448-29.255h5.632l8.395 29.255 7.81-29.255h6.43L50.232 68.593h-7.067l-7.863-27.329-7.917 27.33Zm57.86-19.413c3.24 1.71 5.206 4.813 5.206 8.717 0 3.048-1.062 5.616-3.241 7.648-2.178 2.032-4.782 3.048-7.916 3.048h-15.94V31.156h14.77c3.029 0 5.632 1.016 7.705 2.995q3.188 2.97 3.188 7.38c0 3.263-1.275 5.777-3.773 7.649Zm-7.12-12.248h-8.661v9.84h8.66c2.71 0 4.782-2.138 4.782-4.92 0-2.78-2.072-4.92-4.782-4.92Zm-8.661 25.885h9.83c2.815 0 5.047-2.3 5.047-5.24 0-2.942-2.232-5.242-5.047-5.242h-9.83z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "wildberries_svg__b",
  x1: 0,
  x2: 100,
  y1: 100,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#CB11AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#909"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#481173"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "wildberries_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  fill: "#fff",
  rx: 26
})))));
export default SvgWildberries;